import * as userRequest from "@/utils/userRequest";

export default async function getOverrideRateService(
    onSuccess?: (data?: any) => any,
    handleError?: (err?: any) => any
) {
    try {
        const res = await userRequest.get("/payment-gateway/rate-override");
        if (res.success) {
            onSuccess && onSuccess(res.data);
            return res.data;
        }
    } catch (err) {
        console.error("🚀 ~ getOverrideRateService ~ err:", err);
        handleError && handleError(err);
        throw err;
    }
}
